import { observer } from "mobx-react";
import { VBox } from "@/components-v2/Box";
import { TextQuestion } from "@/dbot/common/commonComponents";
import { RadioButtonGroup } from "@/components-v2/RadioButton";
import { identity } from "lodash";

import { useTranslation } from "@/stores/RootStoreContext";
import { BooleanFieldModel, StringFieldModel } from "@/common/commonForms";

export const IsAccountGiven = observer(function ({
  isAccountGiven,
  isProjectLocked,
  accountNumber,
}: {
  isAccountGiven: BooleanFieldModel;
  isProjectLocked: boolean;
  accountNumber: StringFieldModel;
}) {
  const { t } = useTranslation();
  return (
    <>
      <VBox>
        <div>
          {t("decisions.increaseShareCapitalAgainstCash.payment.addAccountNow.questionText")}
        </div>
        <RadioButtonGroup
          name={"isAccountGiven"}
          options={[true, false]}
          idFn={identity}
          labelFn={(value) =>
            value
              ? t("yes")
              : t("decisions.increaseShareCapitalAgainstCash.payment.addAccountNow.false")
          }
          onChange={(_, option) => isAccountGiven.setValue(option)}
          selected={isAccountGiven.value}
          onBlur={() => isAccountGiven.validate()}
          disabled={isProjectLocked}
        />
      </VBox>
      {isAccountGiven.value && (
        <VBox>
          <TextQuestion
            question={t("decisions.increaseShareCapitalAgainstCash.payment.accountNumber.title")}
            field={accountNumber}
            isLocked={isProjectLocked}
          />
        </VBox>
      )}
    </>
  );
});
